module.exports = __webpack_public_path__ + "static/FImTicketsMockup.8d8128d8.png";